<template>
    <div class="body">
        <transition appear>
          <div v-if="!reportData" class="zhezhao">
              <div class="image" style="width: 100%; height: 13%">
                <img src="@/assets/logo2.png" style="width: 217px; height: 77px; margin-left: 7px"/>
              </div>

              <div class="right" style="width: 100%; height: 87%">
                <p class="font1" style="font-size: 86px; margin-top: 20vh;color: #176ed2;"> 2024富学宝典</p>
                <p class="font1" style=" color: #99345d;font-size: 71px;margin-top: 20px;color: #176ed2;"> 七月学习报告 </p>
                <p class="font1" style="font-size: 41px;margin-top: 27px;color: #2b92c9;"> 坚持学习的人永葆青春 </p>
               
                <div v-show="!Loading" class="input-container" style="margin-top: 4vh">
                  <input v-model="jobNo" type="text" id="input" required="" />
                  <label for="input" class="label">请输入工号</label>
                  <div class="underline"></div>
                </div>
                <div v-show="!Loading" style="display: flex; justify-content: center;margin-top:40px;">
                  <button class="button" @click="inputJobNo()">NEXT</button>
                </div>
                <!-- <LoadingAuguest v-show="Loading" style="margin-top: 30vh" /> -->
              </div>
          </div>
        </transition>
        <main v-if="reportData && reportData.studate != 0" id="main" ref="scrollDiv" class="view">
          <section v-if="reportData.isJinggan===false"  id="section01" class="section">
              <!-- 有学习天数，有学分 -->
              <div v-if="reportData.studate > 0 && reportData.creditvalue > 0" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 10vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">7</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">你已经学习了<span class="font2" style="font-size: 32px;">{{ reportData.studate }}</span>天</p>
                  <p class="font1" style="font-size: 30px;margin-top: 15px;">累计学习了<span class="font2" style="font-size: 32px;">{{ reportData.playtime }}</span >小时</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">学习了<span class="font2" style="font-size: 32px;">{{ reportData.creditvalue }}</span >门课程</p>
                  <p class="font1" style="font-size: 36px;text-align: center;margin-top: 45px;">完成了<span class="font2" style="font-size: 32px;">{{ reportData.creditvalue }}</span >门课程</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">累计考试<span class="font2" style="font-size: 32px;">{{ reportData.creditvalue }}</span >次</p>
                  <p class="font1" style="font-size: 36px;text-align: center;margin-top: 45px;">获得学分<span class="font2" style="font-size: 32px;">{{ reportData.creditvalue }}</span >分</p>
                </div>
              </div>

              <!-- 有学习天数，没有学分 -->
              <div v-if="reportData.studate > 0 && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 10vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">7</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">你在富学宝典平台上的总学习天数达到了<span class="font2" style="font-size: 32px;">{{ reportData.studate }}</span >天</p>
                  <p class="font1" style="font-size: 30px;margin-top: 15px;">但是还没有获得学分，请继续加油！</p>
                  <!-- <p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p> -->
                </div>
              </div>

               <!-- 没有学习天数，没有学分 -->
              <div v-if="!reportData.studate && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 20vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">7</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">你还没有在富学宝典上学习，请继续加油！</p>
                  <!-- <p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p> -->
                </div>
              </div>
          </section>

          <section v-if="reportData.isJinggan===true" id="section01" class="section">

              <div  style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 10vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span></p>
                  <p class="font1" style="font-size: 30px;margin-top: 15px;"><a class="font2">{{ reportData.mtimedate }}</a>是你开启职场生活的第一天，</p>
                  <p class="font1" style="font-size: 30px;margin-top: 15px;">不知不觉，你已经在富士康这个大家庭生活工作了<a class="font2">{{ workdays }}</a>天。</p>

                  <p class="font1" v-if="reportData.studate !==null" style="font-size: 30px;margin-top: 15px;">你已经学习了<a class="font2">{{ reportData.studate }}</a>天</p>
                  <p class="font1" v-if="reportData.playtime !==null" style="font-size: 30px;margin-top: 15px;">累计学习了<a class="font2">{{ reportData.playtime }}</a>小时</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;" v-if="reportData.studate ===null">你还没有在富学宝典上学习<br>请继续加油！</p>
                

                  <p style="padding-top: 3vh;margin: 0;text-align: center;font-size: 30px;">你付出了努力，也收获了成长</p>
                  <p style="margin: 0;text-align: center;font-size: 30px;">这些学习时光是你未来职业发展的坚实基石</p>

                  <p style="padding-top: 3vh;margin: 0;text-align: center;font-size: 30px;">每一天学习都是成长的积累，</p>
                  <p style="margin: 0;text-align: center;font-size: 30px;">愿你在这里绽放光芒！</p>

                </div>
              </div>

          </section>

          <section id="section02" class="section">
              <div class="page2" style="display: flex; flex-wrap: wrap">
                <div class="right" style="width: 100%; margin-top: 10vh">
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">勤学如春起之苗</p>
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">不见其增，日有所长。</p>

                  <p  style="text-align: center;font-weight: 700;color: black; font-size: 30px;margin-top: 21px;">2024年富学宝典上热门课程推荐：</p>
                  <div v-for="(item,index) in mergeBook.slice(0,3)" :key="index" style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #000;">
                     <p @click="redirectToBook(index)" class="font1" style="margin-top: 1vh;">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" ></i></p>
                  </div>

                  <p  v-if="uncompletedLink !==null && uncompletedLink.length>0"  style="text-align: center;font-weight: 700;color: #000; font-size: 30px;margin-top: 21px;">以下课程已学习过半，您离完成目标只差一步之遥：</p>
                  <div  v-for="(item,index) in mergeBook.slice(3)" :key="index+3" style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #000;">
                     <p @click="redirectToBook(index)" class="font1" style="margin-top: 1vh;">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" ></i></p>
                  </div>
                </div>
              </div>
          </section>

          <section id="section03" class="section">
              <div style="display: flex; flex-wrap: wrap">
                <div class="right" style="width: 100%; margin-top: 10vh">
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">勤耕岁月学无涯，</p>
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">积学成才道路赊。</p>
                  <!-- <div>
                    <p class="font1" style="margin: 0 auto; font-size: 30px;color: #000;text-align: center;margin-top: 3vh;">2024年必修课程：</p>
                    <ul style="margin: 0 auto; font-size: 30px;color: #000;;text-align: center;margin-top: 3vh;">
                      <li>{{ coc[0].Name }}&nbsp;&nbsp;<span class="font3" v-if="coc[0].iscompleted===true">已完成</span><span class="font3" v-else>未完成</span></li>
                      <li>{{ coc[1].Name }}&nbsp;&nbsp;<span class="font3" v-if="coc[1].iscompleted===true">已完成</span><span class="font3" v-else>未完成</span></li>
                    </ul>
                    <p style="width: 100%;margin: 0 auto;font-size: 15px;color: #000;margin-top: 3vh;text-align: center;">**具体可登录富学宝典查看:【首页】>【个人设置】>【学习任务】**</p>
                  </div> -->
                  <div>
                    <p class="font1" style="margin: 0 auto; font-size: 30px;color: #000;text-align: center;margin-top: 3vh;">EHS+ESG 八月主题课程推荐：</p>
                    <ul style="margin: 0 auto; font-size: 30px;color: #000;;text-align: center;margin-top: 3vh;">
                      <ul v-for="(item,index) in themeLink" :key="index" ref="">
                          <a :href="item.link" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">《{{ item.Name }}》</li></a>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
          </section>

          <section v-if="reportData.isJinggan===false" id="section04" class="section">
              <div class="page4"  style="display: flex; flex-wrap: wrap">
                <div class="title"><p class="font1" style="font-size: 60px;">好书推荐</p></div>
                    <div class="left" style="margin-top: 40px;width: 80%;margin: 0 auto;">
                        <div class="detail">
                            <p style="text-align: center;font-size: 30px;color: #000;">《释放天赋》》</p>
                            <p class="font2" style="font-size: 18px;text-align: center;">[美]富兰克林·柯维(Franklin Covery)</p>
                        </div>
                        <div class="bookDetail" style="font-size: 17px;padding: 20px;color: #000;">
                            <span style="font-size: 20px;">
                              如何释放员工身上隐藏着的无限潜能是领导者的职责和最重要的工作。——史蒂芬·R.柯维博士<br>
                              富兰克林柯维（FranklinCovey）领导力培训专家将30年的实践经验凝结成三个高效实用;久经检验的对话技巧，掌握这三个技巧，领导者就能化恐惧为信任，化混乱为清晰，化事必躬亲为权力下放，激发员工的无限潜能，打造对手无法复制的竞争优势。<br>
                              阅读本书，你将看到：<br> 
                              1.企业500强企业都在践行的留住能人必备技能。<br>
                              2.具体;清晰的对话指南。指南中包含了所有关键问题与小提示，帮助你打开谈话的匣子，并掌握规避隐患的方法。<br>
                              3.发散思维;拓展运用的讨论题，帮助你更深入地理解书中精要;处理具体问题时的选择和应该关注的重点。<br>
                            </span>
                        </div>
                    </div>
                    <div class="right" style="margin-top: 40px;width: 80%;margin: 0 auto;">
                        <div class="detail">
                          <p style="text-align: center;font-size: 30px;color: #000;">《搞定-无压工作的艺术》</p>
                          <p class="font2" style="font-size: 18px;text-align: center;">[美]戴维·艾伦（David Allen）</p>
                        
                        </div>
                        <div class="bookDetail" style="font-size: 17px;padding: 20px;">
                          <span style="font-size: 20px;text-align: justify;color:#000;">
                            全球工作者都在学习使用的GTD时间管理系统 长踞畅销榜前列的个人事务管理经典 全球数千万人在学习、使用的管理个人事务的优秀工具 风靡全球十馀年，久经考验的GTD时间管理法<br>
                            戴维·艾伦的《搞定I》（Getting Things Done）已经成爲时间管理领域的具影响力的著作之一，书中介绍的GTD（Getting Things Done）时间管理方法也成爲全球千万读者用来轻松高效完成工作与个人事务的优秀工具。GTD看似简单易行，其背后却有深刻的洞见：<br>
                            原则：有效地处理内心的承诺。原则一：养成收集待办事项的习惯。原则二：确定下一步行动。原则三：学会关注结果。<br>
                            目标：解除你精神上的负担，并把事情做好。隻有轻松，才能高效。<br>
                            重要的技巧：把一切事务赶出大脑。如果一件事情总占据着你的头脑，你的思维就会受阻。<br>
                            自下而上的方法：先琐事，再理想。当底层的具体事务得到及时处理后，你也就爲更高一级的思维活动做好了准备。<br>
                            时间管理的本质，是管理我们的心智和行动。<br>
                          </span>
                        </div>
                    </div>         
              </div>
          </section>

          <section v-if="reportData.isJinggan===true" id="section04" class="section">
              <div class="page4"  style="display: flex; flex-wrap: wrap">
                <div class="title"><p class="font1" style="font-size: 60px;">好书推荐</p></div>
                    <div class="left" style="margin-top: 40px;width: 80%;margin: 0 auto;">
                        <div class="detail">
                            <p style="text-align: center;font-size: 30px;color: #000;">《毅力-如何培养自律的习惯》</p>
                            <p class="font2" style="font-size: 18px;text-align: center;">吉姆·兰德尔(Jim Randel)</p>
                        </div>
                        <div class="bookDetail" style="font-size: 17px;padding: 20px;color: #000;">
                            <span style="font-size: 20px;">
                              《毅力:如何培养自律的习惯》爲“简单有趣的个人管理”丛书之一。《毅力:如何培养自律的习惯》作者阅读了大量关于毅力的文章和图书，提炼出了最重要的内容呈现给读者。书中对毅力这一主题进行了分析，帮助你一步步接近你的梦想和目标。《毅力:如何培养自律的习惯》行文生动活泼，配有精美插图，适合一般读者阅读。<br> 
                             
                            </span>
                        </div>
                    </div>
                    <div class="right" style="margin-top: 40px;width: 80%;margin: 0 auto;">
                        <div class="detail">
                          <p style="text-align: center;font-size: 30px;color: #000;">《性格修正-如何突破你的原生性格》</p>
                          <p class="font2" style="font-size: 18px;text-align: center;">[美]本杰明·哈迪（Benjamin Hardy）</p>
                        
                        </div>
                        <div class="bookDetail" style="font-size: 17px;padding: 20px;">
                          <span style="font-size: 20px;text-align: justify;color:#000;">
                            我们常常沉迷于做九型人格、MBTI、DISC等各种性格测试，容易引起共鸣却慢慢发现所获寥寥；感觉人生陷入了停滞，却找不到破局的方法；因爲受过创伤，便可能会放弃对新生活的期待……我们往往认爲性格隻能被找到、性格以类型划分、性格固定不变、性格来自过往经曆、性格是真实自我的反映等，但这却往往使我们变得不再勇敢，逐渐走向平庸，甚至有深深的无力感或陷入困局。<br>
                            本书通过丰富的心理学研究指出，利用性格测试和自身过去等定义“真实自我”和“原生性格”是片面甚至是错误的；并在阐述性格真相和常见五大性格误解的基础上，针对如何正确看待过往、自信定义自我、调整限制自我提升的错误观念和习惯等，在创伤、身份认同叙事、潜意识、环境四大性格影响因素等方面爲读者提供了科学实用的建议，让读者可以从狭隘的性格观念中解放出来，走出困境，实现直接、高效的成长转变。<br>
                            
                          </span>
                        </div>
                    </div>         
              </div>
          </section>

          <section id="section05" class="section">
              <div class="page5" style="position: relative;top: 10vh;">
                    <div style="margin: 0 auto;margin-top: 10vh">
                        <p class="font1" style="font-size: 30px; text-align: center;">你希望在富学宝典平台上遇见哪些好课程呢?</p>
                        <p class="font1"  style="font-size: 28px;text-align: center;margin-top: 2vh;">请写下你的学习清单吧！</p>
                        <form id="form" class="topBefore">
                            <textarea id="message" v-model="comment" type="text" placeholder="MESSAGE"></textarea>
                            <input id="submit"  @click="submit" type="button" value="OK!" />
                        </form>
                    </div>
                    <div style="padding-top: 70px;margin: 0 auto;">
                        <p style="font-size: 48px;text-align: center;color: #000;">THANK YOU!</p>
                        <p class="font1" style="font-size: 48px;text-align: center;">一旦决心学习，谁也拦不住你</p>
                    </div>
              </div>
          </section>

          <section v-if="reportData.isJinggan===true" id="section06" class="section">
              <div class="page6" style="position: relative;top: 10vh;">
                    <div style="margin: 0 auto;margin-top: 10vh">
                        <p class="font1" style="font-size: 30px; text-align: center;">PDP职业性格测试帮助你深入了解自己的性格特质和职业适配性。</p>
                        <p class="font1"  style="font-size: 28px;text-align: center;margin-top: 2vh;">相信自己的独特优势，</p>
                        <p class="font1"  style="font-size: 28px;text-align: center;margin-top: 2vh;">发挥自己潜能</p>
                        <p class="font1"  style="font-size: 28px;text-align: center;margin-top: 2vh;">你将创造更多的职场辉煌</p>
                    </div>
                    <div style="text-align: center;margin-top: 4vh;" v-if="!reportData.pdp">
                        <img  src="@/assets/24July/pdp.png" style="width: 340px;height: 300px;"/>
                    </div>
                    <div style="margin-top: 4vh;" v-if="reportData.pdp">
                        <p class="font1" style="font-size: 28px;padding-top: 1vh;width: 92%;margin: 0 auto;text-align: center;">你已参与过测评，你的职业性格是<a class="font2">{{ reportData.pdp }}型</a></p>
                    </div>
                    <div style="text-align: center;margin-top: 4vh;" v-if="reportData.pdp==='猫头鹰'">
                        <img  src="@/assets/24July/maotouying.png" style="width: 200px;height: 200px;"/>
                    </div>
                    <div style="text-align: center;margin-top: 4vh;" v-if="reportData.pdp==='老虎'">
                        <img  src="@/assets/24July/tiger.png" style="width: 200px;height: 200px;"/>
                    </div>
                    <div style="text-align: center;margin-top: 4vh;" v-if="reportData.pdp==='孔雀'">
                        <img  src="@/assets/24July/peacock.png" style="width: 200px;height: 200px;"/>
                    </div>
                    <div style="text-align: center;margin-top: 4vh;" v-if="reportData.pdp==='考拉'">
                        <img  src="@/assets/24July/koala.png" style="width: 200px;height: 200px;"/>
                    </div>
                    <div style="text-align: center;margin-top: 4vh;" v-if="reportData.pdp==='变色龙'">
                        <img  src="@/assets/24July/bianselong.png" style="width: 200px;height: 200px;"/>
                    </div>
                    <div style="text-align: center;margin-top: 2vh;" v-if="!reportData.pdp">
                        <el-button type="primary" >点击开始测试</el-button>
                    </div>
              </div>
          </section>
        </main>
    </div>
</template>

<script>
import Loading from './Loading.vue'
import viewApi from "@/api/view";
import dataApi from "@/api/data";
import { getArray } from "../../utils/encourage";
export default {
    data(){
      return{
        viewId: "",
        Loading:false,
        reportData:'',
        jobNo:'',
        comment: "",
        source: "",

        recommendBook:'',
        uncompletedLink:'',
        mergeBook:'',
        coc:'',
        themeLink:'',

        workdays:'',
        hireday:'',
      }
    },
    created(){
      document.title = "七月学习报告";
      /* 相信数据begin */
      var test = window.location.href
      let arr = test.split("?code=")
      this.code = arr[1]
      if (this.code) {
        viewApi.getJobNoByBelieve(this.code).then((res) => {
          if(res.data.code === 200) {
            this.jobNo = res.data.data.jobNo
            this.source = "相信"
            if (this.jobNo) {
              this.Loading = true;
              this.getData()
            }
          }
        })
      }
     
      /* 相信数据end */
    },
    methods:{
      submit() {
      if (!this.comment) {
        this.$message({
          message: "请说说您的学习计划",
          type: "warning",
          center: true,
        });
      } else if (this.comment) {
        const view = {
          comment: this.comment,
          studyList: this.studyList,
        };
        view["id"] = this.viewId;
        // console.log(view);
        viewApi.update(view).then((res) => {
          if (res) {
            this.$message({
              message: "提交成功，感谢您的留言。",
              type: "success",
              center: true,
            });
          }
        });
      }
      },
      inputJobNo() {
            if (this.Loading === true) {
              return;
            }
            if (this.jobNo) {
              this.Loading = true;
              this.getData();
            } else {
              this.$message({
                message: "请输入工号",
                type: "warning",
                center: true,
              });
            }
      },
      getData() {
            dataApi.getDataFor24July(this.jobNo).then((res) => {
              this.reportData = res.data.data.data;
              // console.log(res.data.data.data);

              this.recommendBook=JSON.parse(this.reportData.topRecommendLink)
              this.uncompletedLink=JSON.parse(this.reportData.uncompletedLink)
              this.mergeBook=this.recommendBook.concat(this.uncompletedLink)
              const dateTime = new Date(this.reportData.mtimedate)
              const dateOnly = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()+1);
              this.hireday = dateOnly.toISOString().split('T')[0]
              const currentDate = new Date()
              const timeDifference = currentDate.getTime() -dateOnly.getTime();
              this.workdays = Math.floor(timeDifference / (1000 * 60 * 60 * 24))+1;
              // this.coc=JSON.parse(this.reportData.coc)
              this.themeLink=JSON.parse(this.reportData.themeLink)
              if (this.reportData) {
                this.sendViewRecords();
                // this.Loading = false;
                this.reportData.textLab = getArray(this.reportData.textLab);
              } else if (!this.reportData) {
                this.$message({
                  message: "抱歉，暂时找不到您的学习报告！",
                  type: "warning",
                  center: true,
                });
                this.Loading = false;
              }
            });
      },
      sendViewRecords() {
          if (this.jobNo) {
            let viewData = {
              jobNo: this.jobNo,
              device: "PC",
              type: 20,
              browser: this.browser,
            };
            if (this.source) {
              viewData["source"] = this.source;
            }
            viewApi.view(viewData).then((res) => {
              this.viewId = res.data.data.data.id;
            });
          } else {
            return;
          }
      },
      redirectToBook(id){
        const book=this.mergeBook[id]
        const view={
            clickCourseName:book.Name,
            clickCourseLink:book.link
        }
        view["id"] = this.viewId;
        viewApi.update(view).then((res) => {
          if (res.data.code===200) {
            window.location.href = view.clickCourseLink;
          }
        });
      }
    },
    mounted(){
     
    }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
/* 字体样式 */
.font1{
  color:rgb(36, 35, 35); 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
  text-align: center;
}
.font2{
  color: #176ed2; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
}

.font3{
  color: #70b787; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  text-align: center;
}
/* 第一页 */
.body {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}

.zhezhao {
  width: 100vw;
  height: 100vh;
  /* background-image: linear-gradient(170deg, #b55d7f , #953b5d); */
  background:url("../../assets/24July/bg2.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  position: absolute;
  display: flex;
  flex-wrap: wrap;
}
.input-container {
  position: relative;
  margin: 50px auto;
  width: 400px;
}

.input-container input[type="text"] {
  font-size: 20px;
  width: 100%;
  border: none;
  border-bottom: 2px solid #000;
  padding: 5px 0;
  background-color: transparent;
  outline: none;
  color: #67b4dd;
}

.input-container .label {
  position: absolute;
  top: 0;
  left: 0;
  color: #000;
  transition: all 0.3s ease;
  pointer-events: none;
}

.input-container input[type="text"]:focus ~ .label,
.input-container input[type="text"]:valid ~ .label {
  top: -20px;
  font-size: 16px;
  color: #2b92c9;
}

.input-container .underline {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: #67b4dd;
  transform: scaleX(0);
  transition: all 0.3s ease;
}

.input-container input[type="text"]:focus ~ .underline,
.input-container input[type="text"]:valid ~ .underline {
  transform: scaleX(1);
}
.button {
  --bg: #2b92c9;
  --text-color: #67b4dd;
  position: relative;
  width: 150px;
  height: 40px;
  border: none;
  background: var(--bg);
  color: var(--text-color);
  padding: 1em;
  font-weight: bold;
  text-transform: uppercase;
  transition: 0.2s;
  border-radius: 5px;
  opacity: 0.8;
  letter-spacing: 1px;
  box-shadow: #67b4dd 0px 7px 2px, #000 0px 8px 5px;
}

.button:hover {
  opacity: 1;
}

.button:active {
  top: 4px;
  box-shadow: #67b4dd 0px 3px 2px, #000 0px 3px 5px;
}

/* 第二页 */
.view {
  width: 100%;
  height: 100%;
  background:url("../../assets/24July/bg2.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  /* background-image: linear-gradient(170deg, #7a94ac , #a2bed8); */
}
main {
  scroll-snap-type: y mandatory;
  scroll-padding: 80px;
  overflow: scroll;
  height: 100vh;
}
section {
  width: 100vw;
  height: 100vh;
  scroll-snap-align: start;
}
#section01,#section02,#section03,#section04{
  position: relative;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #fff;
    text-align: center;
}
li {
    align-items: center;
    margin-bottom: 8px; 
}

/* li::before {
    content: '\2022'; 
    color: #fff;
    font-size: 1.5em;
    margin-right: 3px; 
    margin: 0 auto;
} */

/*书籍推荐页 */
.title {
  font-size: 50px;
  width: 100%;
  margin-bottom: 30px;
  margin-top: 30px;
}


/* 最后的输入框 */
#form {
  position: relative;
  width: 40vw;
  padding-top: 50px;
  margin: 0 auto;
}

input {
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  width: 570px;
  height: 50px;
  padding: 0px 15px 0px 15px;
  background: transparent;
  outline: none;
  color: #000;
  border: solid 1px #fff;
  border-bottom: none;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}

input:hover {
  background: #fff;
  color: #000;
}

textarea {
  width: 40vw;
  max-width: 40vw;
  height: 20vh;
  max-height: 20vh;
  padding: 0;
  background: transparent;
  outline: none;
  color: #000;
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  border: solid 1px #36854f;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}

/* textarea:hover {
  background: #e89fbb;
  color: #fff;
} */

#submit {
  width:  40vw;
  padding: 0;
  margin: -5px 0px 0px 0px;
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  color: #000;
  outline: none;
  cursor: pointer;
  border: solid 1px #36854f;
  border-top: none;
}

#submit:hover {
  color: #b3aca7;
}
/* 

*/
</style>